const INVALID_FIELD = '[aria-invalid="true"]';
const ALERT = '[role="alert"]';

const prefersReducedMotion = () =>
  window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false;

/* An alert is not focusable on its own; tabIndex -1 lets focus land on it so a screen
 * reader reads it, without adding it to the tab order. */
export default function revealFirstProblem(container) {
  const target =
    container?.querySelector(INVALID_FIELD) ?? container?.querySelector(ALERT);

  if (!target) return;

  if (
    target.getAttribute("role") === "alert" &&
    !target.hasAttribute("tabindex")
  ) {
    target.setAttribute("tabindex", "-1");
  }

  target.scrollIntoView?.({
    block: "center",
    behavior: prefersReducedMotion() ? "auto" : "smooth",
  });
  target.focus({ preventScroll: true });
}
